import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';

export const VideoPreview = ({ videoId }: { videoId: string }) => {
  // Maxresdefault is the highest quality image available, but will return 404 for lower quality videos
  // HQdefault seems to always return a valid image
  const videoPreviewUrl = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <Box
      width="100%"
      flex="1 1 auto"
      justifyContent="center"
      alignItems="center"
      mb={3}
    >
      <Box
        width="60%"
        data-testid="media-preview"
        extend={() => ({
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundImage: `url(${videoPreviewUrl})`,
          aspectRatio: '16/9',
        })}
      />
    </Box>
  );
};
